import { KYMW5500Model } from '../kymw5500.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * CWSアイコンマスタ削除
 *
 * @export API通信成功時の処理
 * @class GetKYMW5500ListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateImageFileListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW5500Model;
  private successFunc: Function;
  private vo: any;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetKYMW5500ListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        ImageFileList: {
          combination: this.vo.imageFileList.map(imagefile => {
            return {
              parameter: {
                ImageId: imagefile.ImageId,
                ImageFileName: imagefile.ImageFileName,
                ImagePathId: imagefile.ImagePathId
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW5500Model} model
   * @param {any} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetKYMW5500ListService
   */
  execute(model: KYMW5500Model, vo: any, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('updateImageFileList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetKYMW5500ListService
   */
  success(data: any) {
    this.model.kymw5500Component.popupLog(data, '1');
    this.model.kymw5500Component.imageFileListReload();
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
